import { render } from "./Team.vue?vue&type=template&id=4f3e3b3b"
import script from "./Team.vue?vue&type=script&lang=js"
export * from "./Team.vue?vue&type=script&lang=js"

import "./Team.vue?vue&type=style&index=0&id=4f3e3b3b&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__